import {Component} from "@angular/core";
import {AdminNavbarComponent} from "../navbar/navbar";
import {NavigationService} from "../../../../navigation/NavigationService";
import {IDeviceInfo} from "../../../../device/IDeviceInfo";

/**
 * Created by Benoit Valkenberg on 03-12-17.
 */
@Component({
    selector: "top-admin-navbar",
    styleUrls: ['./TopAdminNavbar.scss'],
    templateUrl: "./TopAdminNavbar.html"
})
export class TopAdminNavbarComponent extends AdminNavbarComponent{

    public navBarName = "top";
    private deviceInfo:IDeviceInfo;

    constructor(navigationService:NavigationService, deviceInfo:IDeviceInfo){
        super(navigationService);
        this.deviceInfo = deviceInfo;
    }


    ngOnInit(){
        this.isMobile =  this.deviceInfo.IsMobile();
        let url = window.location.href;
        let route = url.slice(url.lastIndexOf("admin" ), url.length);
        this.DetectCurrentRoute(route, this.navBarName);
    }

    logoClicked(){
        this.navigationService.Navigate("/index");
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/navbar/top-navbar/TopAdminNavbar.ts